export default __webpack_public_path__ + "static/media/resources-optimization.c441cda4.png";